const analytics = { enable(){}, disable(){}, setGlobalProperty(){}, track(){} };
export default analytics;
export { analytics };
